<template>
  <div class="newletter-draft">
    <base-form
      v-if="!isLoading && (newsletterTypes && Object.keys(newsletterTypes).length > 0)"
      :data="data"
      :created-at="createdAt"
      :is-updating="isUpdating"
      :newsletter-types="newsletterTypes"
    />

    <div
      v-else
      class="newletter-draft__loader"
    >
      <loading-icon
        :loading="true"
        loading-class="text-center vertical-middle"
      />

    </div>
  </div>
</template>

<script>
import gateway from '@/gateway'
import {warningNotification} from '@/notifications'
import moment from 'moment'
import BaseForm from './DraftForms/Base'

const getDraft = (id, cb) => {
  gateway.get('/newsletters/drafts/' + id)
      .then((response) => {
        cb(null, response.data)
      })
      .catch((err) => {
        cb(err, null)
      })
}

export default {
  components: {
    BaseForm,
  },

  metaInfo () {
    return {
      title: this.data && this.data.subject ? this.data.subject : 'Create Newsletter',
    }
  },

  data () {
    return {
      isLoading: true,
      isUpdating: false,
      error: null,
      newsletterTypes: [],
      createdAt: null,
    }
  },

  beforeRouteEnter (to, from, next) {
    let revision
    if (to.params.draftId) {
      getDraft(to.params.draftId, (err, post) => {
        next((vm) => vm.setData(err, post))
      })
    } else {
      next((vm) => {
        vm.setData(null, {
          latestRevision: revision,
        })
      })
    }
  },

  beforeRouteUpdate (to, from, next) {
    getDraft(to.params.draftId, (err, post) => {
      this.setData(err, post)
      next()
    })
  },

  mounted () {
    this.getNewsletterTypes()
  },

  methods: {
    async getNewsletterTypes () {
      const {data} = await gateway.get('/newsletters/types')
      this.newsletterTypes = data.data
    },

    setData (err, data) {
      if (err) {
        if (err.response && err.response.status === 404) {
          this.$notify(warningNotification('The Newsletter Draft wasn\'t found'))
          this.$router.push({name: 'newsletters'})
        }

        return
      }
      this.isUpdating = data.data ? data.data.isUpdating : false
      this.data = data.data ? data.data.latestRevision : {}
      this.createdAt = data.data ? data.data.createdAt : moment().toISOString()
      this.isLoading = false
    },
  },
}
</script>

<style lang="scss">
.newletter-draft {
  &__loader {
    height: calc(100vh - 200px);
    display: flex;
    align-items: center;
    justify-content: center;
  }
}
</style>

